<uni-box>
    <app-loading-mask *ngIf="loading"></app-loading-mask>
    <div class="card-message">
        <div class="card-message-title">
            <h3>{{ value }}</h3>
        </div>
        <h6>{{ message }}</h6>       
    </div>
</uni-box>